export const NAMESPACE = 'POSTS_AUDIENCE/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_SEARCH_TYPE = NAMESPACE + 'SET_SEARCH_TYPE';
export const ADD_ACTIVITY_TYPE = NAMESPACE + 'ADD_ACTIVITY_TYPE';
export const REMOVE_ACTIVITY_TYPE = NAMESPACE + 'REMOVE_ACTIVITY_TYPE';
export const SET_POSTS_MIN = NAMESPACE + 'SET_POSTS_MIN';
export const SET_POSTS_MAX = NAMESPACE + 'SET_POSTS_MAX';
